import {
  WorkspaceElementReference,
  WorkspaceElement,
  WorkspaceElementSpecs,
} from '@integration-app/sdk'
import useSWR from 'swr'

import { useWorkspace } from 'components/Workspaces/workspace-context'

export function useWorkspaceElement(
  elementRef: WorkspaceElementReference | undefined,
) {
  const { engineAdminFetcher } = useWorkspace()

  const apiRoute = elementRef
    ? WorkspaceElementSpecs[elementRef.type].apiPath
    : null
  const elementRoute = apiRoute ? `/${apiRoute}/${elementRef?.id}` : null

  const { data: element, isLoading } = useSWR<WorkspaceElement>(
    elementRoute,
    engineAdminFetcher,
  )

  return { element, isLoading }
}
